import { Routes } from '@angular/router';
// import { NavRoutes } from './layout/nav/nav.routes';
// import { ContainerRoutes } from './layout/container/container.routes';
// import { SignupComponent } from './layout/signup/signup.component'
// import { SignupRoutes } from './layout/signup/signup.routes'

export const routes: Routes = [ 
    // ...ContainerRoutes, 
    // ...NavRoutes,
    // ...SignupRoutes,
    // { path: 'signup', loadChildren: './layout/signup/signup.module#SignupModule' },
    // { path: 'forgetpassword', loadChildren: './layout/loginpage/forgetpasswordpage/forgetpassword.module#ForgetpasswordModule' },
    // { path: 'devicepage', loadChildren: './layout/devicepage/devicepage.module#DevicepageModule' },
    // { path: 'mousepage', loadChildren: './layout/devicepage/mousepage/mousepage.module#MousepageModule' },
    // { path: 'keyboardpage', loadChildren: './layout/devicepage/keyboardpage/keyboardpage.module#KeyboardpageModule' },
    // { path: 'earphonepage', loadChildren: './layout/devicepage/earphonepage/earphonepage.module#EarphonepageModule' },
    // { path: 'signup', loadChildren: ()=> SignupModule},
    // { path: 'signup', component: SignupComponent },
    // { path: '/layout/signup', component: SignupComponent }
];